import { Icon, Link } from '@/shared-ui/atoms';
import { cn } from '@/lib/utils';
import {
    SOCIAL_MEDIA_PLATFORM_ICONS,
    SOCIAL_MEDIA_PLATFORM_LABELS,
    type SocialMediaPlatformId,
} from '@/extensions/snk/lib/social-media-platforms';
import { getSafeHttpUrl } from '@/extensions/snk/lib/url-utils';

export interface SocialMediaIconProps {
    platform: SocialMediaPlatformId;
    url: string;
    className?: string;
}

export const SocialMediaIcon = ({ platform, url, className }: SocialMediaIconProps) => {
    const safeUrl = getSafeHttpUrl(url);
    if (!safeUrl) {
        return null;
    }

    const PlatformIcon = SOCIAL_MEDIA_PLATFORM_ICONS[platform];
    const label = SOCIAL_MEDIA_PLATFORM_LABELS[platform];

    return (
        <Link
            data-slot="social-media-icon"
            to={safeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={cn('inline-flex', className)}>
            <Icon icon={PlatformIcon} className="h-6 w-auto" decorative={false} title={label} />
        </Link>
    );
};
